import { render } from "./taskLink.vue?vue&type=template&id=6ea1f080"
import script from "./taskLink.vue?vue&type=script&lang=js"
export * from "./taskLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__